import { jsx as _jsx } from "react/jsx-runtime";
import { SettingsGroup, SettingsItem } from '@modules/ide-provisioner/application-settings/app-build-settings/settings-group/settings-group';
export function VmOptionsPreview(props) {
    const { vmOptions } = props;
    return (_jsx(SettingsGroup, { groupName: "VM Options", children: vmOptions.map(vmOption => (_jsx(SettingsItem, { children: vmOption.value }, vmOption.value))) }));
}
